import _ from 'lodash'
import buildService, { NoParams } from 'common/utils/build-service'
import { POST } from 'common/requests'

export const ADD_ACTIVITY_STREAM_ITEM = 'ADD_ACTIVITY_STREAM_ITEM'

interface ActivityItemRaw {
  event_key: string
  created_at: string | Date
  seen_at?: string | null
  payload?: { scope?: string }
  scope?: string
}

const transformActivityItem = (item: ActivityItemRaw) => ({
  ...item,
  eventType: item.event_key,
  createdAt: _.isDate(item.created_at) ? item.created_at : new Date(item.created_at),
  seenAt: item.seen_at ? new Date(item.seen_at) : undefined,
  scope: _.get(item, 'payload.scope', _.get(item, 'scope')),
})

export const getActivityStreamService = buildService<NoParams, unknown, unknown, unknown>({
  type: POST,
  constantsPrefix: 'ACTIVITY_STREAM',
  http: {
    createApiUrlSuffix: () => '/rpc/activity_stream',
    headers: {
      Accept: 'application/json',
      Prefer: 'params=single-object',
    },
  },
  isArray: true,
  addItemActionType: ADD_ACTIVITY_STREAM_ITEM,
  transformItem: transformActivityItem as (payload: unknown) => unknown,
})

export const markActivityStreamService = buildService<NoParams, unknown, unknown, unknown>({
  type: POST,
  constantsPrefix: 'ACTIVITY_STREAM_MARK',
  http: {
    createApiUrlSuffix: () => '/rpc/activity_stream_mark_read',
    headers: {
      Accept: 'application/json',
      Prefer: 'params=single-object',
    },
  },
})

export const getAnnouncementsService = buildService<NoParams, unknown, unknown, unknown>({
  type: POST,
  constantsPrefix: 'ANNOUNCEMENTS',
  isArray: true,
  http: {
    createApiUrlSuffix: () => '/rpc/activity_stream',
    defaultData: {
      from: '2022-01-01',
      max_rows: 25,
      scope: 'auth',
    },
    headers: {
      Accept: 'application/json',
      Prefer: 'params=single-object',
    },
  },
  transformItem: transformActivityItem as (payload: unknown) => unknown,
})

export const postActivityStreamMessageService = buildService<NoParams, unknown, unknown, unknown>({
  type: POST,
  constantsPrefix: 'ACTIVITY_STREAM_MESSAGE',
  http: {
    createApiUrlSuffix: () => '/rpc/activity_stream_post_message',
    headers: {
      Accept: 'application/json',
      Prefer: 'params=single-object',
    },
  },
})

export const deleteAnnouncementService = buildService<NoParams, unknown, unknown, unknown>({
  type: POST,
  constantsPrefix: 'DELETE_ANNOUNCEMENTS',
  http: {
    createApiUrlSuffix: () => `/rpc/activity_stream_delete_message`,
    headers: {
      Accept: 'application/json',
      Prefer: 'params=single-object',
    },
  },
})
